import axios from "axios";

const ALGOLIA_APP_ID = window.algoliaKeys.id;
const ALGOLIA_API_KEY = window.algoliaKeys.key;

// Axios instance
const algolia = axios.create({
  baseURL: `https://${ALGOLIA_APP_ID}-dsn.algolia.net/1/`,
  headers: {
    'X-Algolia-Application-Id': ALGOLIA_APP_ID,
    'X-Algolia-API-Key': ALGOLIA_API_KEY,
  },
});

const indexNames = {
  usedProducts: "used_products",
  newProducts: "new_products",
}

const state = {
  usedProductIndex: window.addEnvPrefToIndex ? window.addEnvPrefToIndex(indexNames.usedProducts) : null,
  newProductIndex: window.addEnvPrefToIndex ? window.addEnvPrefToIndex(indexNames.newProducts) : null,
};

const getters = {};

const mutations = {
  REFRESH_INDEXES(state) {
    state.usedProductIndex = window.addEnvPrefToIndex(indexNames.usedProducts)
    state.newProductIndex = window.addEnvPrefToIndex(indexNames.newProducts)
  }
};

const actions = {
  getNew({ state }, params) {
    const categoryQuery = {
      hitsPerPage: params.hitsPerPage,
      page: params.page,
      maxValuesPerFacet: 2000,
      query: params.query,
      facets: params.new.facets,
      indexName: params.index ? params.index : state.newProductIndex,
      sortFacetValuesBy: 'alpha',
    };

    const subCategoryQuery = {
      hitsPerPage: params.hitsPerPage,
      page: params.page,
      maxValuesPerFacet: 2000,
      query: params.query,
      facets: params.new.facets,
      indexName: params.index ? params.index : state.newProductIndex,
      sortFacetValuesBy: 'alpha',
    };

    const requests = [
      categoryQuery,
    ];

    if (params.category) {
      categoryQuery.filters = `(category:"${params.category}")`;

      if (params.subcategories.length) {
        subCategoryQuery.filters = categoryQuery.filters + ` AND (${params.subcategories.map(cat => `subcategory:"${cat}"`).join(' OR ')})`;

        requests.push(subCategoryQuery);
      }
    }

    if (params.toggles.length) {
      if (subCategoryQuery.filters) {
        subCategoryQuery.filters += ` AND (${params.toggles.map(t => `${t.index}:${t.value}`).join(' AND ')})`;
        categoryQuery.filters += ` AND (${params.toggles.map(t => `${t.index}:${t.value}`).join(' AND ')})`;
      }

      if (!subCategoryQuery.filters && categoryQuery.filters) {
        categoryQuery.filters += ` AND (${params.toggles.map(t => `${t.index}:${t.value}`).join(' AND ')})`;
      }

      if (!subCategoryQuery.filters && !categoryQuery.filters) {
        categoryQuery.filters = `${params.toggles.map(t => `${t.index}:${t.value}`).join(' AND ')}`
      }
    }

    // if (categoryQuery.filters && subCategoryQuery.filters) {
    //   categoryQuery.filters = categoryQuery.filters.replace(/\(category:.*?\)\s*(AND\s*)?/, '');
    //
    //   if (!categoryQuery.filters) {
    //     delete categoryQuery.filters;
    //   }
    // }

    return algolia.post('indexes/*/queries', { requests })
      .then((response) => {
        const [responseForCategory, responseForSubs] = response.data.results;

        return {
          responseForCategory,
          responseForSubs,
        }
      });
  },
  getUsed({ state }, params) {
    const industryQuery = {
      hitsPerPage: params.hitsPerPage,
      page: params.page,
      maxValuesPerFacet: 2000,
      query: params.query,
      facets: params.used.facets,
      indexName: params.index ? params.index : state.usedProductIndex,
      sortFacetValuesBy: 'alpha',
    };

    const categoryQuery = Object.assign({}, {
      hitsPerPage: params.hitsPerPage,
      facets: params.used.facets,
      page: params.page,
      maxValuesPerFacet: 2000,
      query: params.query,
      indexName: params.index ? params.index : state.usedProductIndex,
      sortFacetValuesBy: 'alpha',
    });

    const filterQuery = Object.assign({}, {
      hitsPerPage: params.hitsPerPage,
      facets: params.used.facets,
      page: params.page,
      maxValuesPerFacet: 2000,
      query: params.query,
      indexName: params.index ? params.index : state.usedProductIndex,
      sortFacetValuesBy: 'alpha',
    });

    const yearQuery = Object.assign({}, {
      facets: ['model_year'],
      maxValuesPerFacet: 2000,
      indexName: params.index ? params.index : state.usedProductIndex,
      sortFacetValuesBy: 'alpha',
    });

    const requests = [
      industryQuery,
      filterQuery,
      yearQuery,
    ];

    if (params.industry) {
      filterQuery.filters = industryQuery.filters = `industry:"${params.industry}"`;

      if (params.categories.length) {
        filterQuery.filters = industryQuery.filters = categoryQuery.filters = industryQuery.filters + ` AND (${params.categories.map(cat => `category:"${cat}"`).join(' OR ')})`;

        requests.push(categoryQuery);
      }
    }

    if (params.toggles.length) {
      if (categoryQuery.filters) {
        industryQuery.filters = filterQuery.filters = categoryQuery.filters += ` AND (${params.toggles.map(t => `${t.index}:${t.value}`).join(' AND ')})`;
      }

      if (!categoryQuery.filters && industryQuery.filters) {
        filterQuery.filters = industryQuery.filters += ` AND (${params.toggles.map(t => `${t.index}:${t.value}`).join(' AND ')})`;
      }

      if (!categoryQuery.filters && !industryQuery.filters) {
        filterQuery.filters = industryQuery.filters = `${params.toggles.map(t => `${t.index}:${t.value}`).join(' AND ')}`
      }
    }

    if (params.advanced.options && Object.keys(params.advanced.options).length) {
      const options = Object.keys(params.advanced.options);

      if (categoryQuery.filters) {
        industryQuery.filters = filterQuery.filters = categoryQuery.filters += ` AND (${options.map(l => `options:'${l}'`).join(' AND ')})`;
      }

      if (!categoryQuery.filters && industryQuery.filters) {
        filterQuery.filters = industryQuery.filters += ` AND (${options.map(l => `options:'${l}'`).join(' AND ')})`;
      }

      if (!categoryQuery.filters && !industryQuery.filters) {
        filterQuery.filters = industryQuery.filters = `${options.map(l => `options:'${l}'`).join(' AND ')}`
      }
    }

    if (params.advanced.manufacturer && Object.keys(params.advanced.manufacturer).length) {
      const manufacturer = Object.keys(params.advanced.manufacturer);
      if (categoryQuery.filters) {
        industryQuery.filters = filterQuery.filters = categoryQuery.filters += ` AND (${manufacturer.map(m => `manufacturer:'${m}'`).join(' OR ')})`;
      }

      if (!categoryQuery.filters && industryQuery.filters) {
        filterQuery.filters = industryQuery.filters += ` AND (${manufacturer.map(m => `manufacturer:'${m}'`).join(' OR ')})`;
      }

      if (!categoryQuery.filters && !industryQuery.filters) {
        filterQuery.filters = industryQuery.filters = `${manufacturer.map(m => `manufacturer:'${m}'`).join(' OR ')}`
      }
    }

    if (params.advanced.location && Object.keys(params.advanced.location).length) {
      const locations = Object.keys(params.advanced.location);
      if (categoryQuery.filters) {
        industryQuery.filters = categoryQuery.filters += ` AND (${locations.map(l => `location:'${l}'`).join(' OR ')})`;
      }

      if (!categoryQuery.filters && industryQuery.filters) {
        industryQuery.filters += ` AND (${locations.map(l => `location:'${l}'`).join(' OR ')})`;
      }

      if (!categoryQuery.filters && !industryQuery.filters) {
        industryQuery.filters = `(${locations.map(l => `location:'${l}'`).join(' OR ')})`
      }
    }

    if (params.advanced.model_year && params.advanced.model_year.start_year) {
      const start = params.advanced.model_year.start_year;

      if (categoryQuery.filters) {
        industryQuery.filters = filterQuery.filters = categoryQuery.filters += ` AND (model_year>=${start})`;
      }

      if (!categoryQuery.filters && industryQuery.filters) {
        filterQuery.filters = industryQuery.filters += ` AND (model_year>=${start})`;
      }

      if (!categoryQuery.filters && !industryQuery.filters) {
        filterQuery.filters = industryQuery.filters = `model_year>=${start}`
      }
    }

    if (params.advanced.model_year && params.advanced.model_year.end_year) {
      const start = params.advanced.model_year.end_year;

      if (categoryQuery.filters) {
        industryQuery.filters = filterQuery.filters = categoryQuery.filters += ` AND (model_year<=${start})`;
      }

      if (!categoryQuery.filters && industryQuery.filters) {
        filterQuery.filters = industryQuery.filters += ` AND (model_year<=${start})`;
      }

      if (!categoryQuery.filters && !industryQuery.filters) {
        filterQuery.filters = industryQuery.filters = `model_year<=${start}`
      }
    }

    // todo use it example for refactoring upper if
    if (filterQuery.filters) {
      filterQuery.filters = filterQuery.filters.replace(/\(location:.*?\)\s*(AND\s*)?/, '');

      if (!filterQuery.filters) {
        delete filterQuery.filters;
      }
    }
    // todo use it example for refactoring upper if
    if (industryQuery.filters) {
      industryQuery.filters = industryQuery.filters.replace(/\s*(AND\s*)\(category:.*?\)/, '');

      if (!industryQuery.filters) {
        delete industryQuery.filters;
      }
    }

    return algolia.post('indexes/*/queries', { requests })
      .then((response) => {
        const [responseForIndustry, responseWithLocation, responseWithYear, responseForSubs] = response.data.results;

        return {
          responseForIndustry,
          responseWithLocation,
          responseWithYear,
          responseForSubs,
        }
      });
  },
  async searchAllProducts( {state}, { query, promoIds, isClearance} ){

    if (!ALGOLIA_APP_ID || !ALGOLIA_API_KEY){
      console.error('algoliaKeys are not set');
      throw new Error("algoliaKeys are not set")
    }

    // Build the filters string
    let filters = '';

    // Add clearance filter only if `isClearance` is true
    if (isClearance === true) {
      filters += `is_clearance:true`;
    }

    // Add promo IDs filter
    if (promoIds && promoIds.length > 0) {
      const promoFilter = promoIds.map((id) => `promos.id:${id}`).join(' OR ');
      filters += (filters ? ' OR ' : '') + `${promoFilter}`;
    }

    if (!query){
      query = ""
    }

    // Multi-index search query
    const queries = [
      {
        indexName: state.usedProductIndex,
        query,
        filters: filters,
        hitsPerPage:750
      },
      {
        indexName: state.newProductIndex,
        query,
        filters: filters,
        hitsPerPage:750
      },
    ];

    try {
      // Make request to Algolia API
      const response = await algolia.post('indexes/*/queries', { requests: queries });

      // Return response data
      return response.data;
    } catch (error) {
      console.error('Error while searching products:', error);
      throw error;
    }
  },

  async fetchFirstUsedWithTechReview() {
    const query = [
      {
        indexName: state.usedProductIndex,
        query: '',
        filters:"is_tech_reviewed:true",
        hitsPerPage:8
      }
    ];

    try {
      // Make request to Algolia API
      const response = await algolia.post('indexes/*/queries', { requests: query });

      // Return response data
      return response.data.results[0].hits;
    } catch (error){
      console.error('Error while fetching the tech reviewed items:', error);
      throw error;
    }
  }

}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./resources/js/store/modules/algolia.js